var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("report-page", {
    attrs: {
      title: _vm.name,
      "data-to-send": _vm.dataToSend,
      "buttons-disabled": _vm.buttonsDisabled,
      "history-filter": _vm.historyFilter,
      selectedWorkspaceUUID: _vm.selectedWorkspace
    },
    scopedSlots: _vm._u([
      {
        key: "reportForm",
        fn: function() {
          return [
            _c(
              "report-field",
              { attrs: { "field-name": _vm.$tc("Workspace", 1) } },
              [
                _c("treeselect", {
                  attrs: {
                    options: _vm.workspaceOptions,
                    disabled:
                      !_vm.hasPermissionToCreateExport ||
                      _vm.workspaceSelectionDisabled ||
                      !_vm.userHasManagementPermission("workspace", "list"),
                    disableFuzzyMatching: ""
                  },
                  model: {
                    value: _vm.selectedWorkspace,
                    callback: function($$v) {
                      _vm.selectedWorkspace = $$v
                    },
                    expression: "selectedWorkspace"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "report-field",
              {
                attrs: {
                  "field-name": _vm.$tc(_vm.reportParameters[0].label, 2)
                }
              },
              [
                _c("treeselect", {
                  attrs: {
                    options: _vm.networkStartingPointOptions,
                    "load-options": _vm.getNetworkStartingPointOptions,
                    multiple: true,
                    "value-consists-of": "LEAF_PRIORITY",
                    "default-expand-level": 1,
                    disabled:
                      !_vm.hasPermissionToCreateExport ||
                      _vm.technicalSitesFieldDisabled ||
                      !_vm.userHasPermissionToList("technical_local"),
                    disableFuzzyMatching: ""
                  },
                  on: { input: _vm.resetClosureOptions },
                  model: {
                    value: _vm.reportParameters[0].value,
                    callback: function($$v) {
                      _vm.$set(_vm.reportParameters[0], "value", $$v)
                    },
                    expression: "reportParameters[0].value"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "report-field",
              {
                attrs: {
                  "field-name": _vm.$tc(_vm.reportParameters[1].label, 2)
                }
              },
              [
                _c("treeselect", {
                  attrs: {
                    options: _vm.closureOptions,
                    "load-options": _vm.loadClosureOptions,
                    "auto-load-root-options": false,
                    multiple: true,
                    "value-consists-of": "LEAF_PRIORITY",
                    "default-expand-level": 1,
                    disabled:
                      !_vm.hasPermissionToCreateExport ||
                      _vm.mainFieldsDisabled ||
                      !_vm.userHasPermissionToList("closure"),
                    disableFuzzyMatching: ""
                  },
                  model: {
                    value: _vm.reportParameters[1].value,
                    callback: function($$v) {
                      _vm.$set(_vm.reportParameters[1], "value", $$v)
                    },
                    expression: "reportParameters[1].value"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "report-field",
              {
                attrs: {
                  "field-name": _vm.$tc(_vm.reportParameters[2].label, 2)
                }
              },
              [
                _c("treeselect", {
                  attrs: {
                    options: _vm.mduOptions,
                    "load-options": _vm.loadMDUOptions,
                    "auto-load-root-options": false,
                    multiple: true,
                    "value-consists-of": "LEAF_PRIORITY",
                    "default-expand-level": 1,
                    disabled:
                      !_vm.hasPermissionToCreateExport ||
                      _vm.mainFieldsDisabled ||
                      !_vm.userHasPermissionToList("technical_local"),
                    disableFuzzyMatching: ""
                  },
                  model: {
                    value: _vm.reportParameters[2].value,
                    callback: function($$v) {
                      _vm.$set(_vm.reportParameters[2], "value", $$v)
                    },
                    expression: "reportParameters[2].value"
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-647b06b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-647b06b8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/Tabs/Reports/ReportsPages/Splices.vue
// module id = null
// module chunks = 